import React, { useMemo } from 'react';
import classnames from 'classnames';
import shortid from 'shortid';
import { castArray, isNil, slice, noop, size, isEmpty, get } from 'lodash';
import ReactTooltip from 'react-tooltip';
import { Tooltip } from 'modules/tooltip';
import { getLabel } from 'utils/getLabel';

// import TextTruncate from 'react-text-truncate';

// local dependencies
import { DATA_TYPES, GLOBAL_LABELS } from 'constants/common';
import { getDisplayValue } from 'resolvers/formatValue';
import { Icon } from 'modules/icon-bank';

/**
 * @desc Data cell view for description data cells.
 * @example
 * import { descriptionText as DescriptionTextCellView } from './cellViews/descriptionText.view';
 */

const TruncatedString = ( props ) => {

	const _string = isEmpty( props.string ) ? '' : props.string;
	const result = [];
	const showCopyIcon = get( props, 'config.showCopyIcon', false );
	if(  108 < _string.length ) {
		result.push(

			// <div key={ props.uniqId } >
			<>
				{ _string.substring( 0, 105 ) }
				<a
					data-tip
					data-for={ props.uniqId }
					className='ui-table-cell-view-description-text__display-values__items__item__overflow'
				>
					Read More
				</a>
			</>

			// </div>
		);
	} else {
		result.push( <div key={ props.uniqId } >{ _string }</div> );
	}

	// handles text copying
	const handleCopyToClipboard = () => {

		// Copies text to clipboard
		navigator.clipboard.writeText( _string );
	};

	return (
		<div className='ui-table-cell-view-description-text__display-values__items__item__container'>
			<div className='ui-table-cell-view-description-text__display-values__items__item'>{ result } </div>

			{ ( !isEmpty( _string ) && showCopyIcon ) ? (
				<Tooltip
					text={ getLabel( GLOBAL_LABELS.DISPLAY_TEXT_COPY ) }
					render={ ( binding = {} ) => (
						<div { ...binding } className='ui-table-cell-view-description-text__display-values__items__item__copy'
						onClick= { handleCopyToClipboard }
						>
							<Icon id='copy' />
						</div>
					) }
				/>
			) : null }

		</div>
	);
};

export const descriptionText = ( props ) => {

	// get proper display value
	const value = getDisplayValue( { type: props.columnType, value: props.value } ); // includes(  DATA_TYPES.CURRENCY, props.columnType  ) ? `$${ props.value }` : props.value;

	// extract display values and field values
	const displayValues = castArray( value );

	// get visible display values based on `maxDisplayValues`
	const isValueTruncated =
		!isNil( props.maxDisplayValues ) && 1 < size( displayValues );
	const visibleDisplayValues = isValueTruncated
		? slice( displayValues, 0, props.maxDisplayValues )
		: displayValues;

	// dynamic class name
	const widgetClassName = classnames(
		'ui-table-cell-view-description-text',
		props.className,
		{
			'ui-table-cell-view-description-text--truncated': isValueTruncated,
			'ui-table-cell-view-description-text--actionable': props.isActionable,
		}
	);

	// unique id
	const uniqId = useMemo( shortid.generate, [] );

	return (
		<div className={ widgetClassName }>
			{ /* display values */ }
			<div
				className='ui-table-cell-view-description-text__display-values'
				onClick={ props.onClick }
			>
				{ /* items */ }
				<div className='ui-table-cell-view-description-text__display-values__items'>
					{ visibleDisplayValues.map( ( visibleDisplayValue, index ) => {
						return (

							// <TextTruncate
                            //     key={ index }
							// 	containerClassName='ui-table-cell-view-description-text__display-values__items__item'
							// 	line={ ! isNil( props.ellipsesLineCount ) ? props.ellipsesLineCount : 1}
							// 	element='div'
							// 	truncateText='…'
							// 	text={ visibleDisplayValue }
							// 	textTruncateChild={
							// 		<a
                            //             data-tip
                            //             data-for={ uniqId }
							// 			className='ui-table-cell-view-description-text__display-values__items__item__overflow'
							// 		>
							// 			Read More
							// 		</a>
							// 	}
							// />

							<TruncatedString key={ index } string={ visibleDisplayValue } uniqId={ uniqId } config= { props.config } />
							
						);
					} ) }
				</div>
			</div>

			{ /* tooltip */ }
			{
				<ReactTooltip
					id={ uniqId }
					aria-haspopup='true'
					delayShow={ 300 }
					className='ui-table-cell-view-description-text__tooltip'
					backgroundColor={ '#cdd7e1' }
				>
					{ displayValues.map( ( _valItem, _index ) => {
						return (
							<p
								key={ _index }
								className='ui-table-cell-view-description-text__tooltip__value'
							>
								{ _valItem }
							</p>
						);
					} ) }
				</ReactTooltip>
			}
		</div>
	);
 };

// display name
descriptionText.displayName = 'table.cellViews.descriptionText';

// default values
descriptionText.defaultValues = {
	uniqId: shortid.generate(  ),
	value: [  ],
	maxDisplayValues: undefined,
	isSearchable: false,
	searchQuery: '',
	columnType: DATA_TYPES.DESCRIPTION,
	isActionable: false,
	onClick: noop,
 };
